import React from "react";

function NoTemplate() {
  return (
    <div className="h-100" style={{ padding: "20%" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="37"
        viewBox="0 0 37 37"
        fill="none"
      >
        <path
          d="M1.03589 1.03577L35.643 35.6429"
          stroke="#727271"
          strokeWidth="1.37097"
        />
        <path
          d="M35.6431 1.03577L1.03592 35.6429"
          stroke="#727271"
          strokeWidth="1.37097"
        />
      </svg>
    </div>
  );
}

export default NoTemplate;
